import { TextButton } from 'seagull';
import { AttachFile } from 'seagull/icons';
import { DEFAULT_MAX_TOTAL_SIZE } from "../../hooks/useAttachFiles";
import { useLocaleKeys } from "../../i18n";
import styles from "./AttachFiles.module.scss";
import { AttachFilesTestIds } from "./AttachFiles.utils";
import { jsx as _jsx } from "react/jsx-runtime";
const AttachFiles = _ref => {
  let {
    attachments,
    openFilePicker,
    isUploading,
    maxTotalSize = DEFAULT_MAX_TOTAL_SIZE,
    disabled
  } = _ref;
  const {
    t
  } = useLocaleKeys('invoice.attachFiles');
  const currentTotalSize = attachments.reduce((sum, file) => sum + file.fileSize, 0);
  const isSizeExceeded = currentTotalSize >= maxTotalSize;
  const isDisabled = disabled || isSizeExceeded || isUploading;
  const maxTotalSizeMB = maxTotalSize / (1024 * 1024);
  const getTooltip = () => {
    if (isUploading) {
      return {
        title: t.tooltipUploading(),
        'data-testid': AttachFilesTestIds.ButtonTooltip()
      };
    }
    if (isSizeExceeded) {
      return {
        title: t.tooltipExceededLimit({
          maxSizeMB: maxTotalSizeMB
        }),
        'data-testid': AttachFilesTestIds.ButtonTooltip()
      };
    }
    return undefined;
  };
  return /*#__PURE__*/_jsx(TextButton, {
    className: styles.button,
    "data-testid": AttachFilesTestIds.Button(),
    underline: "none",
    onClick: openFilePicker,
    prefixIcon: /*#__PURE__*/_jsx(AttachFile, {}),
    disabled: isDisabled,
    tooltip: getTooltip(),
    children: t.button()
  });
};
export default AttachFiles;